module.exports = __webpack_public_path__ + "static/media/19ESCAP17.63f26d82.jpg";